<div class="row">
    <div class="col-lg-12 grid-margin">
        <div class="card">
            <div class="card-body upper-header">
            <div class="row">
            <div class="form-group col-2" style="padding-right: 10px;box-sizing: border-box;">
                <label>PNR No.*</label>
                <input #autofocus class="form-control border-primary" type="text"
                        [(ngModel)]="pnr_no" name="pnr_no">
                <div class="inaild_no" *ngIf="errorMsg">{{errorMsg}}</div>
            </div>
            <div class="form-group col-2" style="padding-right: 10px;box-sizing: border-box;">
                <label>Date</label>
                <input class="form-control border-primary" [owlDateTime]="dt" placeholder="Date" name="from_date"
                [(ngModel)]="from_date" readonly>
                <span [owlDateTimeTrigger]="dt" class="date-ico"><i class="fa fa-calendar"></i></span>
                <owl-date-time #dt [pickerType]="'calendar'" [pickerMode]="'dialog'"></owl-date-time>
            </div>
            <div class="form-group col-2" style="padding-right: 10px;box-sizing: border-box;">
                <button type="button" style="margin-top: 30px;" class="btn btn-inverse-primary btn-fw top-btn-head" (click)="loadData()">Load</button>
            </div>
            </div>
            <h4 *ngIf="registraionDetail" class="card-title">
                    <div class="d-flex bd-highlight align-items-center">
                        <div class="p-2 flex-grow-1 bd-highlight">Registration Details</div>
                        
                    </div>
                </h4>
            <div *ngIf="registraionDetail">
                <div class="card">
                    <div class="card-body" style="padding-top: 0;">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="detail-row mb-3">
                                    <label class="detail-label"><strong>PNR No.</strong></label>
                                    <p class="detail-value">{{registraionDetail?.pnr_no}}</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="detail-row mb-3">
                                    <label class="detail-label"><strong>Registration ID</strong></label>
                                    <p class="detail-value">{{registraionDetail?.id}}</p>
                                </div>
                            </div>
                            
                            <div class="col-md-4">
                                <div class="detail-row mb-3">
                                    <label class="detail-label"><strong>Number of Persons</strong></label>
                                    <p class="detail-value">{{registraionDetail?.no_of_persons}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="detail-row mb-3">
                                    <label class="detail-label"><strong>Name</strong></label>
                                    <p class="detail-value">{{registraionDetail?.first_name}} {{registraionDetail?.last_name}}</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="detail-row mb-3">
                                    <label class="detail-label"><strong>Mobile Number</strong></label>
                                    <p class="detail-value">{{registraionDetail?.mobile_no}}</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="detail-row mb-3">
                                    <label class="detail-label"><strong>State</strong></label>
                                    <p class="detail-value">{{registraionDetail?.state?.name}}</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="detail-row mb-3">
                                    <label class="detail-label"><strong>City</strong></label>
                                    <p class="detail-value">{{registraionDetail?.city?.name}}</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="detail-row mb-3">
                                    <label class="detail-label"><strong>Darshan Type</strong></label>
                                    <p class="detail-value">{{registraionDetail?.darshan_type?.name}}</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="detail-row mb-3">
                                    <label class="detail-label"><strong>Time of Visit</strong></label>
                                    <p class="detail-value">{{registraionDetail?.time_of_visit}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="p-12"
                *ngIf="errorMsg">
            <span class="ng-star-inserted no_data">No Data found.</span>
            </div>
            <div *ngIf="registraionDetail" style="display: flex; align-items: end;justify-content: end;">
            <button class="btn btn-primary btn-fw" (click)="saveData()">Print</button>
            </div>
        </div>
    </div>
</div>
